// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Captcha_wrapper__G0y_z","container":"Captcha_container__q1t__","wrapperError":"Captcha_wrapperError__T_Usz"};